// // src/hooks/useAxiosInstance.js
// import { useSelector } from 'react-redux';
// import axios from 'axios';


// //export const API_URL = 'http://localhost:3003/hoa';
// // export const API_URL = 'http://122.165.187.198:3003/hoa';
// export const API_URL = 'https://swine-tight-definitely.ngrok-free.app/hoa';
// //export const API_URL = 'http://vhoas.com:3003/hoa';

// //  export const API_URL = 'http://ec2-34-237-242-88.compute-1.amazonaws.com/hoa';

// const useAxiosInstance = () => {
//   const token = useSelector((state) => state.auth.token);
//   const communityId = useSelector((state) => state.auth.communityId);
//   const userId = useSelector((state) => state.auth.userId);

//   if (!token) {
//     console.warn("Token is not available");
//     return null;
//   }

//   const instance = axios.create({
//     baseURL: process.env.REACT_APP_API_URL || API_URL,
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//       "X-User-Id": userId,
//       "X-Community-Id": communityId,
//     },
//   });

//   return instance;
// };

// export default useAxiosInstance;

// src/hooks/useAxiosInstance.js
import { useSelector } from 'react-redux';
import axios from 'axios';


//export const API_URL = 'http://localhost:3003/hoa';
// export const API_URL = 'http://122.165.187.198:3003/hoa';
// export const API_URL = 'https://swine-tight-definitely.ngrok-free.app/hoa';
// export const API_URL = 'https://fashion-reserves-administrative-marsh.trycloudflare.com/hoa';
export const API_URL = 'https://ensures-deutsche-appearance-clock.trycloudflare.com/hoa';
//export const API_URL = 'http://vhoas.com:3003/hoa';

//  export const API_URL = 'http://ec2-34-237-242-88.compute-1.amazonaws.com/hoa';

const useAxiosInstance = () => {
  const token = useSelector((state) => state.auth.token);
  const communityId = useSelector((state) => state.auth.communityId);
  const userId = useSelector((state) => state.auth.userId);

  if (!token) {
    console.warn("Token is not available");
    return null;
  }

  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || API_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-User-Id": userId,
      "X-Community-Id": communityId,
      "ngrok-skip-browser-warning": "any", // Add this line to bypass ngrok warning
    },
  });

  return instance;
};

export default useAxiosInstance;